import './App.css';
import { ClientProvider } from './hooks/useFetchIp';
import { SeachInputProvider } from './hooks/useSearchInput';
import Map from './components/Map';
import Header from './components/Header';

function App() {
    return (
        <SeachInputProvider>
            <ClientProvider>
                <Header />
                <Map width={'100%'} height={'60%'} />
            </ClientProvider>
        </SeachInputProvider>
    );
}

export default App;
